import { createApiRef } from '@backstage/core-plugin-api';
import type {
  FeedbackItem,
  FeedbackStatusRequest,
  FeedbackSubmitRequest,
} from '@internal/plugin-techdocs-feedback-common';

export interface TechDocsFeedbackApi {
  submit(input: FeedbackSubmitRequest): Promise<{ id: string; status: 'ok' }>;
  list(): Promise<FeedbackItem[]>;
  updateStatus(id: string, input: FeedbackStatusRequest): Promise<FeedbackItem>;
}

export const techdocsFeedbackApiRef = createApiRef<TechDocsFeedbackApi>({
  id: 'plugin.techdocs-feedback.service',
});
